// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Preloader_wrapper__3Go-x"};